
document.addEventListener("DOMContentLoaded", function() {
  
  var submitButtons = document.querySelectorAll('form button[type="submit"], form input[type="submit"]');
  var numButtons = submitButtons.length;
  
  submitButtons.forEach(function(button) {
      var form = button.closest('form');
      if (form) {
          var formId = form.id;
          var checkCnt = 0;
          var checkboxesWithDataConsPreference = form.querySelectorAll('input[data-cons-preference]');
          checkboxesWithDataConsPreference.forEach(function(checkbox) {
              checkCnt++;
          });
              
          button.addEventListener('click', function(event) {
              
              if(checkCnt>=1 && form.checkValidity()){
                event.preventDefault();
                
                if (typeof _iub !== 'undefined') {
                    // estrazione email
                    var subjectId   = 'undefined';
                    var emailValue  = 'undefined';
                    var emailInputs = form.querySelectorAll('input[type="email"]');
                    emailInputs.forEach(function(emailInput) {
                        emailValue = emailInput.value;
                        subjectId = emailValue.toLowerCase().replace(/\W/g, '-');
                    });
                    
                    // estrazione nome
                    var firstName = 'undefined';
                    var firstNameInput = form.querySelector('input[data-cons-subject="first_name"]') || 
                                        form.querySelector('input[name="contact[first_name]"]');
                    if(firstNameInput && firstNameInput.value) {
                        firstName = firstNameInput.value;
                    }
                    
                    // estrazione cognome
                    var lastName = 'undefined';
                    var lastNameInput = form.querySelector('input[data-cons-subject="last_name"]') || 
                                       form.querySelector('input[name="contact[last_name]"]');
                    if(lastNameInput && lastNameInput.value) {
                        lastName = lastNameInput.value;
                    }
                    
                    // estrazione nome completo
                    var fullName = 'undefined';
                    var fullNameInput = form.querySelector('input[data-cons-subject="full_name"]');
                    if(fullNameInput && fullNameInput.value) {
                        fullName = fullNameInput.value;
                    } else if(firstName !== 'undefined' && lastName !== 'undefined') {
                        fullName = firstName + ' ' + lastName;
                    }
                    
                    // costruisco l'oggetto subject con i dati disponibili
                    var subjectData = { 
                        id: subjectId, 
                        email: emailValue 
                    };
                    
                    if(firstName !== 'undefined') {
                        subjectData.first_name = firstName;
                    }
                    if(lastName !== 'undefined') {
                        subjectData.last_name = lastName;
                    }
                    if(fullName !== 'undefined') {
                        subjectData.full_name = fullName;
                    }
                    
                    // estrazione preferences dai checkbox
                    var preferencesData = {};
                    var preferencesCheckboxes = form.querySelectorAll('input[data-cons-preference]');
                    preferencesCheckboxes.forEach(function(checkbox) {
                        var prefKey = checkbox.getAttribute('data-cons-preference');
                        if(prefKey) {
                            // il valore è true se checked, false se non checked
                            preferencesData[prefKey] = checkbox.checked;
                        }
                    });
                    
                    // costruisco l'oggetto consent
                    var consentData = {
                        subject: subjectData,
                        legal_notices: [
                            { identifier: 'privacy_policy', }
                        ]
                    };
                    
                    // aggiungo preferences solo se ce ne sono
                    if(Object.keys(preferencesData).length > 0) {
                        consentData.preferences = preferencesData;
                    }
                    
                    // invio sincrono a iubenda
                    _iub.cons_instructions.push(["submit", {
                        writeOnLocalStorage: false,
                        form: { 
                            selector: document.getElementById(formId),
                        },
                        consent: consentData
                    },{
                        success: function(response) { 
                            form.submit();
                        }, 
                        error: function(response) { 
                            console.error('Iubenda consent error:', response);
                            form.submit();
                        }
                    }])
                } else {
                    form.submit();
                }
                
              }
          }) 
          
      }
  });

});
